import { useAuth as useClerkAuth, useOrganization, useUser } from "@clerk/clerk-react";
import type { QueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

export interface AuthSnapshot {
  isLoaded: boolean;
  isSignedIn: boolean;
  userId: string | null;
  orgId: string | null;
  getToken: () => Promise<string | null>;
}

export function useAuthSnapshot(): AuthSnapshot {
  const { isLoaded, isSignedIn, userId, getToken } = useClerkAuth();
  const { organization } = useOrganization();
  return {
    isLoaded,
    isSignedIn: !!isSignedIn,
    userId: userId ?? null,
    orgId: organization?.id ?? null,
    getToken,
  };
}

export function useEmail(): string | null {
  const { user } = useUser();
  return user?.primaryEmailAddress?.emailAddress ?? null;
}

export function useOrgChangeFlush(orgId: string | null, queryClient: QueryClient) {
  const last = useRef<string | null>(orgId);
  useEffect(() => {
    if (last.current !== null && last.current !== orgId) {
      // queryClient.clear() drops all cached entries, including the loader's
      // ensureQueryData results — the next render refetches automatically.
      // router.invalidate() would be redundant here.
      queryClient.clear();
    }
    last.current = orgId;
  }, [orgId, queryClient]);
}
